<template>
  <section>
    <div>
      <b-button-toolbar aria-label="button-toolbar" class="mb-2 float-right" key-nav>
        <b-dropdown class="mx-1" right text="Menu">
          <b-dropdown-item>
            <b-button :disabled="busy" squared variant="outline-info" @click="getStudies()"
              >Refresh local db
            </b-button>
          </b-dropdown-item>
          <b-dropdown-item>
            <b-button v-b-modal.verifyUpdate :disabled="busy" squared variant="outline-danger"
              >Get Studies from Redshift
            </b-button>
          </b-dropdown-item>
          <b-dropdown-item>
            <b-button v-b-modal.truncateDatabase :disabled="busy" squared variant="danger"
              >Truncate Studies in local db
            </b-button>
          </b-dropdown-item>
        </b-dropdown>
      </b-button-toolbar>

      <b-table
        :busy.sync="busy"
        :fields="studiesFields"
        :items="studies"
        bordered
        head-variant="dark"
        hover
        responsive="sm"
        striped
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-modal
        id="verifyUpdate"
        centered
        header
        header-bg-variant="danger"
        header-text-variant="light"
        title="Contacting Amazon..."
        @ok="modalOk"
      >
        <p class="font-weight-bold">
          By selecting this option the local database will be erased and filled with new data, are
          you sure?
        </p>
        <template #modal-footer="{ ok, cancel }">
          <b-button variant="danger" @click="cancel()"> Cancel</b-button>
          <b-button @click="ok()"> OK</b-button>
        </template>
      </b-modal>
      <b-modal
        id="truncateDatabase"
        centered
        header
        header-bg-variant="danger"
        header-text-variant="light"
        title="Warning"
        @ok="truncateOk"
      >
        <p class="font-weight-bold">
          This option will wipe the Studies from the local database, are you sure?
        </p>
        <template #modal-footer="{ ok, cancel }">
          <b-button variant="danger" @click="cancel()"> Cancel</b-button>
          <b-button @click="ok()"> OK</b-button>
        </template>
      </b-modal>
    </div>
  </section>
</template>

<script>
  import moment from 'moment';

  export default {
    data() {
      return {
        busy: false,
        studies: [],
        studiesFields: [
          {
            key: 'study_id',
            label: 'Study ID',
          },
          {
            key: 'study_status',
            label: 'Study Status',
            sortable: true,
          },
          {
            key: 'updated_at',
            label: 'Updated Date',
            sortable: true,
            formatter: value => {
              return moment(value).format('MMM DD YYYY, HH:mm');
            },
          },
        ],
      };
    },
    created() {
      // Echo.private('csset-ms').listen('DatabaseUpdated', ({ e }) => {
      //   this.updatedStudiesToast();
      //   this.getStudies();
      // });
      this.updatedStudiesToast();
      this.getStudies();
    },
    methods: {
      updatedStudiesToast() {
        this.$bvToast.toast(`Updating the studies table...`, {
          title: 'Received new data',
          variant: 'success',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-center',
        });
      },
      modalOk() {
        this.updateStudies();
      },
      truncateOk() {
        this.truncateStudies();
      },
      async getStudies() {
        try {
          this.busy = true;
          let response = await axios.get(`/api/csset-ms/vue/studies-from-db`);
          this.studies = response.data;
          this.busy = false;
        } catch (error) {
          this.handleError(error);
          this.busy = false;
          console.log(error);
        }
      },
      async updateStudies() {
        try {
          this.busy = true;
          await axios.get(`/api/csset-ms/vue/update-studies`);
          await this.getStudies();
          this.busy = false;
        } catch (error) {
          this.handleError(error);
          this.busy = false;
          console.log(error);
        }
      },
      async truncateStudies() {
        try {
          this.busy = true;
          await axios.get(`/api/csset-ms/vue/delete-csset-ms-studies-from-db`);
          await this.getStudies();
          this.busy = false;
        } catch (error) {
          this.handleError(error);
          this.busy = false;
          console.log(error);
        }
      },
      handleError(error) {
        if (error.response.status === 500) {
          console.error('getting 500!');
          alert('Server is not responding, please try again later');
        } else if (error.response.status === 404) {
          console.error('getting 404!');
          alert('Not Found (404)');
        } else if (error.response.status === 401) {
          alert('Your session seems to have ended, please refresh');
        } else if (error.response.status === 400) {
          alert(
            'Your request could not be processed, please try to refresh your page or contact support',
          );
        }
      },
    },
  };
</script>
